module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ที่ใช้จัดการ Style ที่เกี่ยวกับ Cursor ประกอบด้วย\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicColor'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Color\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicDisplay'
      }
    }
  }, [_vm._v("\n            Display   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-cursor"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Cursor\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• Cursor")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_cs-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("cursor")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_cs-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("pt")]), _vm._v(": สำหรับ \"pointer\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("h")]), _vm._v(": สำหรับ \"help\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("nal")]), _vm._v(": สำหรับ \"not-allowed\" "), _c('br')])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Cursor")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Cursor -->\n<div class=\"_cs-pt\">Pointer</div>\n<div class=\"_cs-h\">Help</div>\n<div class=\"_cs-nal\">Not Allowed</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_h-32px _bgcl-white _tal-ct _cs-pt _bdw-1px _bdcl-neutral-400 _mgbt-16px"
  }, [_vm._v("Pointer")]), _vm._v(" "), _c('div', {
    staticClass: "_h-32px _bgcl-white _tal-ct _cs-h _bdw-1px _bdcl-neutral-400 _mgbt-16px"
  }, [_vm._v("Help")]), _vm._v(" "), _c('div', {
    staticClass: "_h-32px _bgcl-white _tal-ct _cs-nal _bdw-1px _bdcl-neutral-400"
  }, [_vm._v("Not Allowed")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d10e3e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/document-pages/AtomicCursor.vue
// module id = 123
// module chunks = 0